import { CircularProgress } from "@mui/material";

const LoadingScreen = () => (
  <div className="flex vw-100 vh-100 justify-content-center align-items-center">
    <CircularProgress />
  </div>
);

export default LoadingScreen;
